<template>
  <div
    v-if="!result.query && isAuthorized && reactState.historyList?.length > 0"
    class="search-history"
  >
    <h6 class="search-history__title">
      {{ result.messages?.historyTitle }}
    </h6>
    <div class="search-history-items">
      <button
        v-for="(item, key) in reactState.historyList"
        :key="key"
        type="button"
        class="search-history-item"
        @click="handlerSetValue(item)"
      >
        <svg
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
          class="search-history-item__clock"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.0503 1.25623C7.71797 1.25623 5.4812 2.18272 3.83203 3.8319C2.18285 5.48108 1.25635 7.71785 1.25635 10.0501C1.25635 11.205 1.48381 12.3485 1.92574 13.4154C2.36768 14.4824 3.01544 15.4518 3.83203 16.2684C4.64862 17.085 5.61805 17.7327 6.68498 18.1747C7.7519 18.6166 8.89543 18.8441 10.0503 18.8441C11.2051 18.8441 12.3486 18.6166 13.4155 18.1747C14.4825 17.7327 15.4519 17.085 16.2685 16.2684C17.0851 15.4518 17.7328 14.4824 18.1748 13.4154C18.6167 12.3485 18.8442 11.205 18.8442 10.0501C18.8442 7.71785 17.9177 5.48108 16.2685 3.8319C14.6193 2.18272 12.3826 1.25623 10.0503 1.25623ZM5.01645 5.01633C6.3515 3.68128 8.16222 2.93126 10.0503 2.93126C11.9383 2.93126 13.749 3.68128 15.0841 5.01633C16.4191 6.35138 17.1691 8.1621 17.1691 10.0501C17.1691 10.985 16.985 11.9107 16.6273 12.7744C16.2695 13.6381 15.7451 14.4229 15.0841 15.084C14.423 15.745 13.6382 16.2694 12.7745 16.6271C11.9108 16.9849 10.9851 17.169 10.0503 17.169C9.1154 17.169 8.18969 16.9849 7.32598 16.6271C6.46228 16.2694 5.6775 15.745 5.01645 15.084C4.3554 14.4229 3.83103 13.6381 3.47327 12.7744C3.11551 11.9107 2.93138 10.985 2.93138 10.0501C2.93138 8.1621 3.6814 6.35138 5.01645 5.01633ZM10.8878 5.86256C10.8878 5.40001 10.5128 5.02505 10.0503 5.02505C9.58772 5.02505 9.21275 5.40001 9.21275 5.86256V10.2828C9.21275 10.5049 9.30098 10.7179 9.45805 10.875L12.1102 13.5271C12.4373 13.8542 12.9675 13.8542 13.2946 13.5271C13.6217 13.2001 13.6217 12.6698 13.2946 12.3427L10.8878 9.93587V5.86256Z"
            fill="#5F5F67"
          />
        </svg>
        {{ item }}

        <DefButtonCross @click.stop="handlerRemove(item)" />
      </button>
    </div>
    <DefLinkBrown @click="handlerRemove('')">
      {{ result.messages?.clearHistoryTitle }}
    </DefLinkBrown>
    <!--    <Button type="button" class="search-history-clear">-->
    <!--      -->
    <!--    </Button>-->
  </div>
</template>

<script lang="ts" setup>
import { ISearchResponse } from '@components/Search/ISearch';
import { onBeforeMount, reactive, computed } from 'vue';
import axios from 'axios';
import { useStore } from '@/store';
import DefButtonCross from '@components/Def/DefButtonCross/DefButtonCross.vue';
import DefLinkBrown from '@components/Def/DefLink/DefLinkBrown.vue';

const props = defineProps<{ result: ISearchResponse }>();

const reactState = reactive({ historyList: [] });
const { state, getters } = useStore();

const getRequestLang = computed(() => getters.getRequestLang);

const isAuthorized = computed(() => state?.personal.data?.authInfo?.isAuthorized);
const emit = defineEmits(['select']);

const getHistoryData = async () => {
  const response = await axios.get('/ajax/', {
    params: { action: 'getSearchHistory', ...getRequestLang.value },
  });

  if (Array.isArray(response.data?.history)) {
    reactState.historyList = response.data?.history;
  }
};

const handlerRemove = async (query: string) => {
  // if param q is present remove one.
  // if q is empty remove all list
  const response = await axios.post('/ajax/', { action: 'deleteSearchHistory', q: query });

  if (Array.isArray(response.data?.history)) {
    reactState.historyList = response.data?.history;
  }
};

const handlerSetValue = (value: string) => {
  // console.log(value);
  emit('select', value);
};

onBeforeMount(() => {
  getHistoryData();
});
</script>

<style lang="scss" scoped>
.search-history {
  &__title {
    color: var(--color-dark-grey);
    font-size: 14px;
    font-weight: 500;
    line-height: 125%;
    text-transform: uppercase;
    margin-bottom: 14px;
  }
  :deep(.def-link-brown) {
    font-size: 12px;
    line-height: 125%;
    text-transform: uppercase;
    margin-top: 18px;
  }
}
.search-history-items {
  display: grid;
  grid-row-gap: 12px;
  font-size: 14px;
  font-weight: 500;
  line-height: 125%;
}
.search-history-item {
  display: flex;
  align-items: center;
  gap: 12px;
  &__clock {
    width: 20px;
    height: 20px;
  }
}
</style>
